export enum FineTuneSync {
	SmallRange = 0.05,
	MediumRange = 0.5,
	LargeRange = 1,
	EnableRange = 0.15,
}
